// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectSidebar_wrapper__CqLRU","emptyAssetRow":"ProjectSidebar_emptyAssetRow__1Eg7k"};